import clsx from 'clsx';
import React from 'react';

import { Image } from '@unpic/react';

import { useScreenSize } from '@/hooks/useScreenSize';
import { cn } from '@/lib/utils';

interface QuickViewCardProps {
  className?: string;
  title?: string;
  shortTitle?: string;
  icon?: any;
  discountedPrice?: number;
  price?: number;
  image?: any;
  description?: string;
  tickIcon?: any;
  channelCount?: number;
  titleClassName?: string;
  sysId?: any;
  imgAltText?: any;
}

export const QuickViewCard: React.FC<QuickViewCardProps> = ({
  icon,
  title,
  shortTitle,
  discountedPrice,
  price,
  image,
  description,
  tickIcon,
  className,
  channelCount,
  titleClassName,
  sysId,
  imgAltText,
}) => {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
    isDoubleExtraLargeScreen,
  } = useScreenSize();
  return (
    <div
      className={cn(className, 'flex items-center justify-center text-center')}
      data-testid="quick-view-container"
    >
      <div>
        {icon && (
          <div
            id="icon__container"
            className="py-2 sm:h-[27px] sm:w-[27px] md:h-[35.1px] md:w-[35.1px] lg:h-[45.63px] lg:w-[45.63px] xl:h-[45.63px] xl:w-[45.63px] 2xl:h-[59.32px] 2xl:w-[59.32px]"
          >
            <Image
              width={
                isSmallScreen
                  ? 27
                  : isMediumScreen
                    ? 35.1
                    : isLargeScreen
                      ? 45.63
                      : isExtraLargeScreen
                        ? 45.63
                        : isDoubleExtraLargeScreen
                          ? 59.31
                          : 27
              }
              height={
                isSmallScreen
                  ? 27
                  : isMediumScreen
                    ? 35.1
                    : isLargeScreen
                      ? 45.63
                      : isExtraLargeScreen
                        ? 45.63
                        : isDoubleExtraLargeScreen
                          ? 59.31
                          : 27
              }
              layout="constrained"
              className="bg-cover bg-no-repeat sm:h-[26px] sm:w-[26px] md:h-[17.15px] md:w-[17.15px]"
              alt={imgAltText}
              background="auto"
              src={icon?.url}
              loading="lazy"
              data-contentful-entry-id={sysId}
            />
          </div>
        )}
        {(discountedPrice || price) && (
          <div id="price__container" className="py-2">
            <div>
              <p>
                {discountedPrice && <span className="line-through">{`$ ${discountedPrice}`}</span>}{' '}
                <span className="font-bold">{`$ ${price}`}</span>
              </p>
            </div>
          </div>
        )}
        {channelCount && (
          <div id="title__container" className="py-2">
            <h4>{channelCount}</h4>
          </div>
        )}
        {title && (
          <div id="title__container" className="">
            <h4 className={clsx('h-4', titleClassName)}>{title}</h4>
          </div>
        )}
        {image && (
          <div
            id="image__container"
            className="flex place-items-center items-center justify-center py-2 sm:w-[27px] md:w-[35px] lg:w-[45px] 2xl:w-[59px]"
          >
            <Image
              width={
                isSmallScreen
                  ? 27
                  : isMediumScreen
                    ? 35.1
                    : isLargeScreen
                      ? 45.63
                      : isExtraLargeScreen
                        ? 45.63
                        : isDoubleExtraLargeScreen
                          ? 59.31
                          : 27
              }
              layout="constrained"
              className="bg-cover bg-no-repeat"
              alt={imgAltText}
              background="auto"
              src={image?.url}
              loading="lazy"
              data-contentful-entry-id={sysId}
              aspectRatio={1}
            />
          </div>
        )}
        {description && (
          <div id="description__container" className="py-2">
            <h4>{description}</h4>
          </div>
        )}
        {tickIcon && (
          <div
            id="tick_icon__container"
            className="py-2 sm:w-[20px] md:w-[26px] lg:w-[33.8px] 2xl:w-[43.94px]"
          >
            <Image
              width={
                isSmallScreen
                  ? 27
                  : isMediumScreen
                    ? 35.1
                    : isLargeScreen
                      ? 45.63
                      : isExtraLargeScreen
                        ? 45.63
                        : isDoubleExtraLargeScreen
                          ? 59.31
                          : 27
              }
              layout="constrained"
              className="bg-cover bg-no-repeat"
              alt={imgAltText}
              background="auto"
              src={tickIcon?.url}
              loading="lazy"
              data-contentful-entry-id={sysId}
              aspectRatio={1}
            />
          </div>
        )}
      </div>
    </div>
  );
};
